var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-mk",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d20000",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe600",
    d: "M0 0h96l224 231.4L544 0h96L0 480h96l224-231.4L544 480h96zm640 192v96L0 192v96zM280 0l40 205.7L360 0zm0 480l40-205.7L360 480z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 240,
    r: 77.1,
    fill: "#ffe600",
    stroke: "#d20000",
    strokeWidth: 17.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/mk.31ba11ec4d4cdae74ebc0cbc1b768f44.svg";
export { ForwardRef as ReactComponent };